var emitter = require('tiny-emitter/instance');

export default {
    props: [
        'ulv'
    ],
    data(){
        return {
            user_data: {
                videos: null
            },
            chapters: [],
            current_day_index: null
        }
    },
    methods: {
        setCurrentDay(current_day){
            this.current_day_index = current_day - 1;
            $('.current-day').text(current_day);
        },
        getUserData(appends = [])
        {
            return new Promise((resolve, reject) => {

                this.showLoader('Fetching user data');

                axios.post('/api/user/get-data', {appends: appends}).then((response)=>{
                    this.hideLoader();
                    this.$store.commit('setData', response.data);
                    this.user_data = response.data.user_data;
                    this.chapters = response.data.chapters;

                    this.setCurrentDay(response.data.user_data.current_day);

                    emitter.emit('gotUserData', response.data); // TODO: do we need this?

                    resolve(true);
                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                        console.log(e.response.data);
                        console.log(e.response.status);
                        console.log(e.response.headers);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
        getFirstOfSequenceData(time, is_hls = true){
            return new Promise((resolve, reject) => {

                this.showLoader('Building video sequence');

                const hls_seg = is_hls ? '/hls/' : '/';

                axios.post('/api/user/get-video-sequence' + hls_seg + 'first', {time: time}).then((response)=>{
                    // this.hideLoader();
                    this.setCurrentDay(response.data.current_day);
                    resolve(response);
                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                        console.log(e.response.data);
                        console.log(e.response.status);
                        console.log(e.response.headers);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
        getRestOfSequenceData(time, is_hls = true){
            return new Promise((resolve, reject) => {

                const current_day = this.current_day_index + 1;
                const hls_seg = is_hls ? '/hls/' : '/';

                axios.post('/api/user/get-video-sequence' + hls_seg + 'rest/' + current_day, {time: time}).then((response)=>{
                    resolve(response);
                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                        console.log(e.response.data);
                        console.log(e.response.status);
                        console.log(e.response.headers);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
        getWorkoutLibraryVids(monthly_only = false)
        {
            return new Promise((resolve, reject) => {

                this.showLoader('Fetching videos');

	            let q_string = '';
	            if(monthly_only){
					q_string = 'monthly_only=true&';
	            }

                axios.get('/api/get-workout-library?' + q_string + 'v=' + Date.now()).then((response)=>{

                    if(this.ulv)
                    {
                        for(let i=0; i<response.data.videos.length; i++)
                        {
                            for(let j=0; j<this.ulv.length; j++){
                                if(this.ulv[j].vimeo_id === response.data.videos[i].vimeo_id && !this.ulv[j].seen){
                                    response.data.videos[i].new = true;
                                }
                            }
                        }
                    }

                    this.hideLoader();
                    resolve(response.data);
                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                        console.log(e.response.data);
                        console.log(e.response.status);
                        console.log(e.response.headers);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
        getWorkoutLibraryVid(video_id, hls){
            return new Promise((resolve, reject) => {

                this.showLoader('Fetching video data');

                const hls_string = hls ? '/hls' : '';

                axios.get('/api/get-workout-library/' + video_id + hls_string).then((response)=>{
                    // this.hideLoader();
                    resolve(response);
                }).catch((e) => {
                    if(e.response){
                        alert(e.response.data.message);
                        console.log(e.response.data.message);
                        console.log(e.response.data);
                        console.log(e.response.status);
                        console.log(e.response.headers);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
        pingSequenceCompleted(is_lib_vid = false, watch_time)
        {
            this.ping_state = 'dialling';
            return new Promise((resolve, reject) => {
                axios.post('/api/user/sequence-completed', { current_day: this.current_day_index + 1, lib_vid_data: is_lib_vid, watch_time: watch_time }).then((response)=>{
                    this.ping_state = 'success';

                    if(response.data.next_day){
                        this.next_day = response.data.next_day;
                    }

                    resolve(response.data);
                }).catch((e) => {
                    this.ping_state = 'error';
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                this.ping_state = 'error';
                reject(error);
            });
        },
        pingWorkoutVideoCompleted(video_data, watch_time)
        {
            return new Promise((resolve, reject) => {
                axios.post(`/api/user/workout-video-completed`, {lib_vid_data: video_data, watch_time: watch_time}).then((response)=>{
                    resolve(response.data);
                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
        updateUserSetting(packet_data)
        {
            return new Promise((resolve, reject) => {
                axios.put('/api/user/update-setting', packet_data).then(() => {
                    resolve();
                }).catch((e) => {
                    if (e.response) {
                        console.log(e.response.data.message);
                    } else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                    reject();
                });
            });
        },
        // updateUserSetting(setting_slug, boolean_value)
        // {
        //     return new Promise((resolve, reject) => {
        //
        //         axios.put('/api/user/update-setting', {'setting_slug': setting_slug, 'boolean_value': boolean_value}).then(()=>{
        //             resolve(true);
        //         }).catch((e) => {
        //             if(e.response){
        //                 console.log(e.response.data.message);
        //             }else {
        //                 throw new Error('An error occurred connecting with the server.');
        //             }
        //         });
        //     }).catch((error)=>{
        //         reject(error);
        //     });
        // },
        toggleWorkoutLibraryFavorites(videos)
        {
	        const starred_videos = videos.filter(function(video) {
		        return ['yellow', 'green'].includes(video.starred_status);
	        }).map(video => ({
		        vimeo_id: video.vimeo_id,
		        starred_status: video.starred_status
	        }));

            return new Promise((resolve, reject) => {

                axios.post('/api/user/set-library-favorites', {starred_videos: starred_videos}).then(()=>{
                    resolve(true);
                }).catch((e) => {
                    if(e.response){
                        console.log(e.response.data.message);
                        console.log(e.response.data);
                        console.log(e.response.status);
                        console.log(e.response.headers);
                    }else {
                        throw new Error('An error occurred connecting with the server.');
                    }
                });
            }).catch((error)=>{
                reject(error);
            });
        },
	    deleteLibraryFavorite(vimeo_id)
	    {
		    return new Promise((resolve, reject) => {

			    axios.delete('/api/user/delete-library-favorite/'+vimeo_id).then(()=>{
				    resolve(true);
			    }).catch((e) => {
				    if(e.response){
					    console.log(e.response.data.message);
					    console.log(e.response.data);
					    console.log(e.response.status);
					    console.log(e.response.headers);
				    }else {
					    throw new Error('An error occurred connecting with the server.');
				    }
			    });
		    }).catch((error)=>{
			    reject(error);
		    });
	    },
        appendNewLibraryFavouritesToExistingUserData() // call this after toggling a starred video, so if calendar modal is opened, pending list is synced
        {
            axios.post('/api/user/get-data').then((response)=>{

                this.$store.commit('mergeUpdatedStarredVideos', response.data.user_data.library_favorites);
                emitter.emit('workoutLibraryFavouriteDeleted');

                return true;

            }).catch((e) => {
                if(e.response){
                    console.log(e.response.data.message);
                    console.log(e.response.data);
                    console.log(e.response.status);
                    console.log(e.response.headers);
                }else {
                    throw new Error('An error occurred connecting with the server.');
                }
            });
        }
    },
    computed: {
        full_sequence(){
            if(!this.user_data.selected_videos){
                return null;
            }
            let explicitly_selected = [];

            for(var key in this.user_data.selected_videos){
                if(!this.user_data.selected_videos.hasOwnProperty(key)) continue;
                if(this.user_data.selected_videos[key].active){
                    explicitly_selected.push(this.user_data.selected_videos[key]);
                }
            }
            if(explicitly_selected.length === 0){
                return null;
            }

            let data_array = []; // have to store the sequence data in a temporary array instead of directly pushing to this.full_sequence, otherwise Vue's reactivity system doesn't update :/
            let user_vid = 0;
            for(let day=0; day<7; day++)
            {
                data_array[day] = [];
                for(let vid_no=0; vid_no<5; vid_no++)
                {
                    data_array[day].push(explicitly_selected[user_vid]);
                    user_vid = (user_vid + 1) >= explicitly_selected.length ? 0 : user_vid + 1;
                }
            }
            return data_array;
        }
    }
}
